module.exports = __webpack_public_path__ + "img/cynergy-logo-no-text-black.ff39c9f8.png";